import type { RemoteConnection } from '../relate.types';
import type { Builder } from './types';

export const remoteConnectionEndpoints = (builder: Builder) => ({
  listDbConnections: builder.query<RemoteConnection[], void>({
    query: () => ({
      url: 'list-db-connections',
      method: 'GET',
    }),
    providesTags: ['RemoteConnection'],
    transformResponse: (response: RemoteConnection[]) => response.sort((a, b) => a.name.localeCompare(b.name)),
  }),

  createDbConnection: builder.mutation<
    string,
    { name: string; connectionUri: string; username: string; password: string }
  >({
    query: ({ name, connectionUri, username, password }) => ({
      url: 'create-db-connection',
      method: 'POST',
      body: {
        name,
        connectionUri,
        username,
        password,
      },
    }),
    invalidatesTags: ['RemoteConnection'],
  }),

  updateDbConnection: builder.mutation<
    string,
    { id: string; name?: string; connectionUri?: string; username?: string; password?: string }
  >({
    query: (fieldsToChange) => ({
      url: 'update-db-connection',
      method: 'POST',
      body: fieldsToChange,
    }),
    invalidatesTags: (_res, _err, { id }) => ['RemoteConnection', { type: 'Credentials', id }],
  }),

  removeDbConnection: builder.mutation<void, { connectionId: string }>({
    query: ({ connectionId }: { connectionId: string }) => ({
      url: 'remove-db-connection',
      method: 'POST',
      body: { nameOrId: connectionId },
    }),
    invalidatesTags: ['RemoteConnection'],
  }),
});
